module.exports = __webpack_public_path__ + "static/ilustracao-documentos-fiscais-6eba817f5c667e63abf040071dac1227.svg";